import { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import FJImage from '../../../../../common/components/FJImage/FJImage';
import FJToolTip from '../../../../../common/components/FJToolTip/FJToolTip';
import FJHoverBoardGradation from '../../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJDropdownNew from '../../../../../common/components/FJDropDown/FJDropdownNew';
import { HAIR_COLORS_PREFERENCES } from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import FJMoreIcon from '../../../../../assets/svg/more.svg?react';
import FJConfig from '../../../../../config/FJConfig';

import styles from './FJHeadshotHairColorPicker.module.less';

function FJHeadshotHairColorPicker({ onSelect, value }) {
    const hairColorRef = useRef(null);

    const _renderOverlay = useCallback(
        config => (
            <div className={styles.color_box} ref={config.ref}>
                {HAIR_COLORS_PREFERENCES.map(item => (
                    <FJHoverBoardGradation
                        key={item.key}
                        active={value.key === item.key}
                        borderRadius={9999}
                        isShowInBorder
                    >
                        <FJToolTip title={FJLocalStore._(item.key)}>
                            <div
                                className={styles.color_item}
                                onClick={() => {
                                    onSelect(item);
                                    hairColorRef.current?.hide();
                                }}
                            >
                                <FJImage
                                    imgSrc={FJConfig.hairColorImagePath + item.imageUrl + `?v=${FJConfig.version}`}
                                    boxClassName={styles.img_box}
                                    imgClassName={styles.img}
                                    onRefresh={() => {
                                        onSelect(item);
                                        hairColorRef.current?.hide();
                                    }}
                                />
                            </div>
                        </FJToolTip>
                    </FJHoverBoardGradation>
                ))}
            </div>
        ),
        [onSelect, value],
    );

    const _renderTrigger = useCallback(
        config => (
            <div className={styles.trigger} ref={config.ref} onClick={config.onClick}>
                <FJToolTip title={FJLocalStore._('more')}>
                    <div id='more' className={styles.no_more_icon} onClick={() => hairColorRef.current?.show()}>
                        <FJMoreIcon />
                    </div>
                </FJToolTip>
            </div>
        ),
        [],
    );

    return (
        <div className={styles.container}>
            <FJDropdownNew
                placement='rightTop'
                trigger='click'
                offsetLeft={22}
                ref={hairColorRef}
                renderOverlay={_renderOverlay}
                renderTrigger={_renderTrigger}
                isTopLayer
            />
        </div>
    );
}

FJHeadshotHairColorPicker.propTypes = {
    onSelect: PropTypes.func,
    value: PropTypes.object,
};

export default FJHeadshotHairColorPicker;
